export default __webpack_public_path__ + "static/media/other_white.a1a9662f.svg";